module.exports = __webpack_public_path__ + "img/blue_119.268f5c7d.png";